import _Col from './Col';
import _Row from './Row';

import './style';

export type { ColProps } from './Col';
export type { RowProps } from './Row';

export * from './type';

export const Col = _Col;
export const Row = _Row;
